// import { useState } from 'react';
import { Input, } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const MyPassword = ({ ...rest }) => {
    // const [passwordVisible, setPasswordVisible] = useState(false);
  return (
    <Input.Password
        size='large'
        placeholder="input password"
        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        {...rest}
      />
  )
}

export default MyPassword